let currentSampleUrl;
let currentSampleId;
let currentAudio;

function playSample(e) {
  const id = $(this).data('id');

  if (currentSampleId === id && currentSampleUrl) {
    toggleSample(currentSampleUrl, $(this));
  } else {
    if (currentAudio) {
      resetSample();
    }

    $(this).find('.fa').hide();
    $(this).find('.sample-refresh').show();

    $.get(`/song-sample-url/${id}`).then((res) => {
      if (res.url === null) {
        $(this).find('.fa').show();
        $(this).find('.sample-pause').hide();
        alert('Song sample could not be found.');
      } else {
        toggleSample(res.url, $(this));
      }

      $(this).find('.sample-refresh').hide();
    });
  }

  currentSampleId = id;

  e.preventDefault();
}

function toggleSample(url, btn) {
  if (!currentAudio) {
    currentAudio = new Audio(url);
    currentAudio.pause();

    currentAudio.onpause = function () {
      btn.find('.sample-pause').hide();
      btn.find('.sample-play').show();
    };

    currentAudio.onplay = function () {
      btn.find('.sample-pause').show();
      btn.find('.sample-play').hide();
    };
  }

  if (currentAudio.paused) {
    currentAudio.currentTime = 0;
    currentAudio.play();
  } else {
    currentAudio.pause();
  }

  currentSampleUrl = url;
}

function resetSample() {
  if (currentAudio) {
    currentAudio.pause();
  }

  currentAudio = null;
  currentSampleId = null;
}

module.exports = { playSample, resetSample };
